
import React, { useState } from "react";
import SendEmail from "../../Login/SendEmail/SendEmail";
import { Createuserwithrole } from "../Settings/Helpingfiles/KeycloakHelpmethods";
import "../Settings/Settings.css";

const CreateAccount = (props) => {
  const [username, setusername] = useState("");
  const [firstName, setFirstName] = useState("");
  const [lastName, setLastName] = useState("");
  const [email, setemail] = useState("");
  const [role, setrole] = useState("Client");
  const [payloadrole, setpayloadrole] = useState("/formsflow/formsflow-client");
  const [sendmailallowed, setsendmailallowed] = useState(false);
  const popupoverlay = document.getElementById("popup-root");

  const handler = (e) => {
    e.preventDefault();
    return (popupoverlay.style.display = "none");
  };

  return (
    <div>
      <h1 className="AddUserInCreateAccount">Add User</h1>
      <form>
        <div className="Labels">
          <lable className="FirstNameLabel">
            Enter the email address of users to add
          </lable>
          <input
            type="email"
            onChange={(e) => {
              setemail(e.target.value);
            }}
            value={email}
            className="UserFirstname"
            placeholder="Enter email and hit enter"
          />
        </div>
        <div className="Labels">
          <lable className="FirstNameLabel">User name</lable>
          <input
            onChange={(e) => {
              setusername(e.target.value);
            }}
            value={username}
            type="text"
            className="UserFirstname"
          />
        </div>
        <div className="Labels">
          <lable className="FirstNameLabel">First name</lable>
          <input
            onChange={(e) => {
              setFirstName(e.target.value);
            }}
            value={firstName}
            type="text"
            className="UserFirstname"
          />
        </div>
        <div className="Labels">
          <lable className="FirstNameLabel">Last name</lable>
          <input
            onChange={(e) => {
              setLastName(e.target.value);
            }}
            value={lastName}
            type="text"
            className="UserFirstname"
          />
        </div>
        {/* <div className='Labels'>
          <lable className="FirstNameLabel">Role</lable>
          <input type="text" className='UserFirstname' />
          </div> */}
        <div className="form-group Labels">
          <label for="exampleFormControlSelect1 FirstNameLabel">
            select role
          </label>
          <select
            className="form-control FirstNameLabel"
            value={role}
            onChange={(e) => {
              setrole(e.target.value);
            }}
            id="exampleFormControlSelect1"
          >
            <option className="FirstNameLabel">Client</option>
            <option className="FirstNameLabel">Clerk</option>
            <option className="FirstNameLabel">Approver</option>
          </select>
        </div>
        <div className="UserSubmitButton">
          <button
            onClick={(e) => {
              e.preventDefault();
              props.setOpen(false);
            }}
            className="UserCancelBtn"
          >
            Cancel
          </button>
          <button
            onClick={(e) => {
              e.preventDefault();
              Createuserwithrole(
                username,
                firstName,
                lastName,
                email,
                role,
                payloadrole
              ).then((data) => {
                if (data.ok) {
                  setsendmailallowed(true);
                  props.setOpen(false);
                  alert("User Created Successfully!!!");
                }
              });
            }}
            className="UserCreate"
          >
            Create
          </button>
        </div>
      </form>
      {sendmailallowed && (
        <SendEmail
          clientEmailId={email}
          clientName={username}
          clientrole={role}
        />
      )}
    </div>
  );
};

export default CreateAccount;
